

    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop, Ref, Watch } from "vue-property-decorator";
    import PrimaryButton from "@/vue/components/PrimaryButton.vue";
    import Utils from "@/utilities/Utils";
    import { mapData } from "@/utilities/DataMapping";
    import ApiClient from "@/utilities/ApiClient";
    import { Pathway } from "@/model/Pathway";
    import { SiteRecipientSearchParameters } from "@/model/SiteRecipientSearchParameters";
    import { ISiteRecipient, SiteRecipient } from "@/model/SiteRecipient";

    @Component({ components: { PrimaryButton } })
    export default class PathwayRecipientsDialogue extends Vue {

        siteRecipientList: Array<ISiteRecipient> = [];
        pathwayID: string = Utils.emptyGuidValue;
        isShowing: boolean = false;

        @Prop({ required: true })
        pathwayList!: Array<Pathway>;

        @Prop({ required: true })
        siteId!: string;

        get title(): string {
            const pathway = this.pathwayList?.find(i => i.id === this.pathwayID);
            return `Recipients for ${pathway ? pathway.description : "- - -"}`;
        }

        async show(pathwayID: string) {
            this.pathwayID = pathwayID;
            this.isShowing = true;
            await this.load();
        }

        hide() {
            this.isShowing = false;
        }

        goToRecipients() {
            this.$router.push({ name: "AdminSite", params: { siteID: this.siteId }, query: { tab: "recipients" } });
        }

        async load(): Promise<void> {
            if(Utils.isEmptyId(this.pathwayID)) {
                 this.siteRecipientList = [];
                 return;
            }
            const parameters = new SiteRecipientSearchParameters();
            parameters.siteID = this.siteId;
            parameters.carbonCopyPathwayID = this.pathwayID;
            const data = await ApiClient.post("/Api/SiteRecipient/Search", parameters);
            this.siteRecipientList = mapData<Array<SiteRecipient>>(data, { root: (s) => new SiteRecipient (s) });
        }
    }
